import client from "./client";

export default {

    async getExpenses(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/expenses', filters)));
    },
    async getExpense(id) {
        return client.parseResponse(await client.get('/expenses/' + id));
    },
    async createExpense(data) {
        return client.parseResponse(await client.post('/expenses', data))
    },
    async editExpense(data) {
        return client.parseResponse(await client.put('/expenses/' + data.id, data))
    },
    async deleteExpense(data) {
        return client.parseResponse(await client.delete('/expenses/' + data.id))
    },

    async exportExpensesReport(filters) {
        return client.parseResponse(await client.get('/export-expenses', filters, {responseType: 'blob'}));
    }
}
